import moment from 'moment';
import {ActiveFilter, dateRangeLabel, displayName, namesLabel} from '../../designSystem/filterChips';

export type CallFilterKey = 'contacts' | 'users' | 'date';

export interface CallFilterState {
    contactsFilter: { firstName?: string; lastName?: string }[];
    usersFilter: { firstName?: string; lastName?: string; name?: string }[];
    selectedDates: { from: string; to: string };
}

export function allTimeRange(): { from: string; to: string } {
    return {
        from: moment().subtract(100, 'years').startOf('day').toISOString(),
        to: moment().add(100, 'years').endOf('day').toISOString(),
    };
}

// The store keeps a ±100-year range when no date is chosen (filtersSlice initialState).
export function isDefaultDateRange({from, to}: { from: string; to: string }): boolean {
    return moment(from).isBefore(moment().subtract(50, 'years'))
        && moment(to).isAfter(moment().add(50, 'years'));
}

export function activeCallFilters(state: CallFilterState): ActiveFilter<CallFilterKey>[] {
    const filters: ActiveFilter<CallFilterKey>[] = [];
    if (state.contactsFilter.length) {
        filters.push({key: 'contacts', label: namesLabel(state.contactsFilter.map(displayName))});
    }
    if (state.usersFilter.length) {
        filters.push({key: 'users', label: namesLabel(state.usersFilter.map(displayName))});
    }
    if (!isDefaultDateRange(state.selectedDates)) {
        filters.push({key: 'date', label: dateRangeLabel(state.selectedDates.from, state.selectedDates.to)});
    }
    return filters;
}
